import { render, staticRenderFns } from "./landingPageViewMobile.vue?vue&type=template&id=4767eaa8&"
import script from "./landingPageViewMobile.vue?vue&type=script&lang=js&"
export * from "./landingPageViewMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports